import { routePaths } from '../../../routePaths';
import { translate } from '../../../utils';
import { WarehousePermission } from '../../../generated/graphql';
import { RouteType } from '../../../types';
import { WarehouseCardActionProvider } from '../../../modules/warehouse/providers';
import { WarehouseCards } from '../../../modules/warehouse/components';
import { CreateWarehouseCardForm, UpdateWarehouseCardForm } from '../../../modules/warehouse/components/WarehouseCards';
import WarehouseCardWriteOff from '../../../modules/warehouse/components/WarehouseCards/WarehouseCardsWriteOff';

const WarehouseCardsRoute: RouteType = {
    exact: false,
    showInSideBar: true,
    path: routePaths.warehouseCards,
    title: translate('Warehouse Cards'),
    permissions: {
        warehouse: [WarehousePermission.CanViewStockCard],
    },
    component: WarehouseCards,
    scopeProvider: WarehouseCardActionProvider,
    childrenRoutes: [
        {
            exact: true,
            path: routePaths.warehouseCardsCreate,
            component: CreateWarehouseCardForm,
            title: translate('New warehouse card'),
            permissions: { warehouse: [WarehousePermission.CanAddStockCard] },
            redirectRoute: routePaths.warehouseCards,
        },
        {
            exact: true,
            title: translate('Write-off'),
            path: routePaths.warehouseCardsWriteOff,
            component: WarehouseCardWriteOff,
        },
        {
            path: routePaths.warehouseCardsUpdate,
            component: UpdateWarehouseCardForm,
            title: translate('Update warehouse card'),
            permissions: { warehouse: [WarehousePermission.CanUpdateStockCard] },
            redirectRoute: routePaths.warehouseCards,
        },
    ]
};

export default WarehouseCardsRoute;
